import { Button } from 'components/Elements';
import { Logo } from 'components/Layout/components/Logo';
import { useAuth } from 'lib/auth';
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BGImage from 'assets/image3.webp';

export const Landing = () => {
  const navigate = useNavigate();

  const { user } = useAuth();

  const handleStart = () => {
    // Navigate to the dashboard if logged in; otherwise go to the login page.
    if (user) {
      navigate('/app');
    } else {
      navigate('/auth/login');
    }
  };

  return (
    <div id="root">
      {/* Navigation Bar */}
      <div className="container absolute left-2/4 z-10 mx-auto -translate-x-2/4 p-4">
        <nav className="block w-full max-w-screen-2xl rounded-xl bg-transparent text-gray-200 shadow-none p-3">
          <div className="container mx-auto flex items-center justify-between text-gray-200">
            <Logo />
            <div className="hidden lg:block">
              <ul className="mb-4 mt-2 flex flex-col gap-2 text-inherit lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
                <li className="block antialiased font-sans text-sm font-light leading-normal text-inherit capitalize">
                  <Link className="flex items-center gap-1 p-1 font-bold" to="/auth/login">
                    Login
                  </Link>
                </li>

                <li>
                  <Link
                    to="/docs"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1 p-1 font-bold"
                  >
                    Docs
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>

      {/* Hero Section */}
      <div className="relative flex h-screen content-center items-center justify-center pt-16 pb-32">
        <div
          className={`absolute top-0 h-full w-full bg-cover bg-center`}
          style={{ backgroundImage: `url(${BGImage})` }}
        ></div>
        {/* <div className="absolute top-0 h-full w-full bg-black/60 bg-cover bg-center"></div> */}
        <div className="max-w-8xl container relative mx-auto text-center">
          <h1 className="block antialiased tracking-normal font-sans text-5xl leading-tight text-gray-100 mb-6 font-black">
            WLU Administrator
          </h1>
          <p className="block mb-4 antialiased font-sans text-xl font-normal leading-relaxed text-gray-100 opacity-80">
            Please note that this dashboard is for administrators only. <br /> If you'd like to
            register with us, please visit{' '}
            <a href="https://wlu.ug" target="_blank" className="text-green-400">
              {' '}
              https://wlu.ug
            </a>{' '}
            and register new account.
          </p>
          <Button onClick={handleStart} className="mx-auto">
            {user ? `Welcome back ${user.firstName}` : 'Login to account'}
          </Button>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative px-4 pt-8 pb-6 bg-white">
        <div className="container mx-auto text-center">
          <p className="block antialiased font-sans text-sm leading-normal font-normal text-blue-gray-500">
            Copyright © 2025 Made with ❤️{' '}
            <a
              href="https://ashitacreatives.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-gray-500 transition-colors hover:text-blue-500"
            >
              Ashita Creatives
            </a>
            .
          </p>
        </div>
      </footer>
    </div>
  );
};
